import { DENTAL_SPEECH_TERMS_BASE } from '../constants/dentalSpeechTermsBase';
import type { ClinicSpeechTerm } from '../types';

const HEADER =
  '歯科クリニックの申し送り。歯科・医学用語を正確に書き起こし、一文を途中で切らず全体を出力してください。用語例: ';

/** Whisper API の prompt 用（長さ上限を超えないよう切り詰め） */
export function buildWhisperPrompt(clinicTerms: ClinicSpeechTerm[], maxLen = 800): string {
  const parts: string[] = [];
  for (const t of clinicTerms) {
    const p = t.phrase.trim();
    const r = t.reading.trim();
    if (p) parts.push(p);
    if (r && r !== p) parts.push(r);
  }
  for (const w of DENTAL_SPEECH_TERMS_BASE) {
    parts.push(w);
  }
  const uniq = Array.from(new Set(parts));
  let tail = uniq.join('、');
  const budget = maxLen - HEADER.length;
  if (tail.length > budget) {
    tail = tail.slice(0, budget);
  }
  return HEADER + tail;
}
